import * as tslib_1 from "tslib";
import { Matrix3D, Vector3D } from "@awayjs/core";
import { TraverserBase } from "@awayjs/graphics";
import { HierarchicalProperties } from "../base/HierarchicalProperties";
import { BoundsType } from "../bounds/BoundsType";
import { DirectionalShadowMapper } from "../shadowmappers/DirectionalShadowMapper";
import { LightBase } from "./LightBase";
var DirectionalLight = (function (_super) {
    tslib_1.__extends(DirectionalLight, _super);
    function DirectionalLight(xDir, yDir, zDir) {
        if (xDir === void 0) { xDir = 0; }
        if (yDir === void 0) { yDir = -1; }
        if (zDir === void 0) { zDir = 1; }
        var _this = _super.call(this) || this;
        _this._pAabbPoints = new Array(24);
        _this._pIsEntity = true;
        _this.direction = new Vector3D(xDir, yDir, zDir);
        _this._sceneDirection = new Vector3D();
        //default bounds type
        _this._boundsType = BoundsType.NULL;
        return _this;
    }
    Object.defineProperty(DirectionalLight.prototype, "traverseName", {
        get: function () {
            return DirectionalLight.traverseName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DirectionalLight.prototype, "assetType", {
        get: function () {
            return DirectionalLight.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DirectionalLight.prototype, "sceneDirection", {
        get: function () {
            if (this._sceneDirectionDirty)
                this._updateSceneDirection();
            return this._sceneDirection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DirectionalLight.prototype, "direction", {
        get: function () {
            return this._direction;
        },
        set: function (value) {
            this._direction = value;
            if (!this._tmpLookAt)
                this._tmpLookAt = new Vector3D();
            this._tmpLookAt.x = this.x + this._direction.x;
            this._tmpLookAt.y = this.y + this._direction.y;
            this._tmpLookAt.z = this.z + this._direction.z;
            this.lookAt(this._tmpLookAt);
        },
        enumerable: true,
        configurable: true
    });
    DirectionalLight.prototype.pInvalidateHierarchicalProperties = function (propDirty) {
        if (_super.prototype.pInvalidateHierarchicalProperties.call(this, propDirty))
            return true;
        if (this._hierarchicalPropsDirty & HierarchicalProperties.SCENE_TRANSFORM)
            this._sceneDirectionDirty = true;
        return false;
    };
    DirectionalLight.prototype._updateSceneDirection = function () {
        this._sceneDirectionDirty = false;
        this.transform.concatenatedMatrix3D.copyColumnTo(2, this._sceneDirection);
        this._sceneDirection.normalize();
    };
    //@override
    DirectionalLight.prototype.pCreateShadowMapper = function () {
        return new DirectionalShadowMapper();
    };
    //override
    DirectionalLight.prototype.iGetObjectProjectionMatrix = function (displayObject, cameraTransform, target) {
        if (target === void 0) { target = null; }
        if (!target)
            target = new Matrix3D();
        var m = Matrix3D.CALCULATION_MATRIX;
        m.copyFrom(displayObject.getRenderSceneTransform(cameraTransform));
        m.append(this.transform.inverseConcatenatedMatrix3D);
        if (!this._projAABBPoints)
            this._projAABBPoints = [];
        m.transformVectors(this._pAabbPoints, this._projAABBPoints);
        var xMin = Infinity, xMax = -Infinity;
        var yMin = Infinity, yMax = -Infinity;
        var zMin = Infinity, zMax = -Infinity;
        var d;
        for (var i = 0; i < 24;) {
            d = this._projAABBPoints[i++];
            if (d < xMin)
                xMin = d;
            if (d > xMax)
                xMax = d;
            d = this._projAABBPoints[i++];
            if (d < yMin)
                yMin = d;
            if (d > yMax)
                yMax = d;
            d = this._projAABBPoints[i++];
            if (d < zMin)
                zMin = d;
            if (d > zMax)
                zMax = d;
        }
        var invXRange = 1 / (xMax - xMin);
        var invYRange = 1 / (yMax - yMin);
        var invZRange = 1 / (zMax - zMin);
        var targetData = target._rawData;
        targetData[0] = 2 * invXRange;
        targetData[5] = 2 * invYRange;
        targetData[10] = invZRange;
        targetData[12] = -(xMax + xMin) * invXRange;
        targetData[13] = -(yMax + yMin) * invYRange;
        targetData[14] = -zMin * invZRange;
        targetData[1] = targetData[2] = targetData[3] = targetData[4] = targetData[6] = targetData[7] = targetData[8] = targetData[9] = targetData[11] = 0;
        targetData[15] = 1;
        target.prepend(m);
        return target;
    };
    /**
     * //TODO
     *
     * @protected
     */
    DirectionalLight.prototype._pUpdateBoxBounds = function () {
        _super.prototype._pUpdateBoxBounds.call(this);
        //update points
        var minX = this._pBoxBounds.x;
        var minY = this._pBoxBounds.y - this._pBoxBounds.height;
        var minZ = this._pBoxBounds.z;
        var maxX = this._pBoxBounds.x + this._pBoxBounds.width;
        var maxY = this._pBoxBounds.y;
        var maxZ = this._pBoxBounds.z + this._pBoxBounds.depth;
        this._pAabbPoints[0] = minX;
        this._pAabbPoints[1] = minY;
        this._pAabbPoints[2] = minZ;
        this._pAabbPoints[3] = maxX;
        this._pAabbPoints[4] = minY;
        this._pAabbPoints[5] = minZ;
        this._pAabbPoints[6] = minX;
        this._pAabbPoints[7] = maxY;
        this._pAabbPoints[8] = minZ;
        this._pAabbPoints[9] = maxX;
        this._pAabbPoints[10] = maxY;
        this._pAabbPoints[11] = minZ;
        this._pAabbPoints[12] = minX;
        this._pAabbPoints[13] = minY;
        this._pAabbPoints[14] = maxZ;
        this._pAabbPoints[15] = maxX;
        this._pAabbPoints[16] = minY;
        this._pAabbPoints[17] = maxZ;
        this._pAabbPoints[18] = minX;
        this._pAabbPoints[19] = maxY;
        this._pAabbPoints[20] = maxZ;
        this._pAabbPoints[21] = maxX;
        this._pAabbPoints[22] = maxY;
        this._pAabbPoints[23] = maxZ;
    };
    return DirectionalLight;
}(LightBase));
export { DirectionalLight };
DirectionalLight.traverseName = TraverserBase.addEntityName("applyDirectionalLight");
DirectionalLight.assetType = "[light DirectionalLight]";



// WEBPACK FOOTER //
// ../dist/lib/display/DirectionalLight.js